module.exports = __webpack_public_path__ + "static/img/Jordan-Miller.d65e59d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jordan-Miller.jpg
// module id = rF0m
// module chunks = 0